module.exports = __webpack_public_path__ + "img/error.8d994a12.svg";